import _ from 'lodash';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import './App.css';
import { checkSessionTimeout, getLocalstorage, saveParamMode, setLocalstorage } from './common/utils/other';
import DefaultLayout from './layouts/Default';
import { AdminRoutes} from './routes/protected-routes';
import { PublicRoutes } from './routes/public-routes';
import { layoutActions } from './store/actions';
import { TARGET } from './common/utils/const';

function App(props) {
    const { loggedIn, user } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    saveParamMode();

    React.useEffect(() => {
        if (loggedIn) {
            checkSessionTimeout();
        }
    }, []);

    const routes = React.useMemo(() => {
        let ret = _.cloneDeep(AdminRoutes);
        return Object.values(ret);
    }, []);

    /**
     * renders
     */
    function renderPublicRoutes() {
        const sourceLocal = getLocalstorage(TARGET);
        console.log(sourceLocal);
        return (
            <Routes>
                {Object.values(PublicRoutes)?.map((route) => {
                    return <Route key={route.id} path={route.path} element={<route.component />} />;
                })}

                <Route path="*" element={<Navigate to={`/login${sourceLocal ? '?'+TARGET+'='+sourceLocal : ''}`} />} />
            </Routes>
        );
    }
    function renderProtectedRoutes() {
        // if (user?.userStatus === "FORCE_CHANGE_PASSWORD") {
        //   const _route = Object.values(PublicRoutes)[1]
        //   const Comp = _route.component
        //   return (
        //     <Routes>
        //       <Route path={_route.path} element={<Comp />} />
        //     </Routes>
        //   )
        // }
        const sourceLocal = getLocalstorage(TARGET);
        const search = window.location.search;
        const params = new URLSearchParams(search);
        let source = params.get(TARGET);
        let url = "/dashboard";
        if (sourceLocal) {
            url += `?${TARGET}=${sourceLocal}`;
        }

        return (
            <DefaultLayout {...props} routes={Object.values(routes)}>
                <Routes>
                    {Object.values(routes)?.map((route) => {
                        if (route.children) {
                            return route.children.map((child) => {
                                return <Route key={child.id} path={child.path} element={<child.component />} />;
                            });
                        }
                        return <Route key={route.id} path={route.path} element={<route.component />} />;
                    })}

                    <Route path="*" element={<Navigate to={url} />} />
                </Routes>
            </DefaultLayout>
        );
    }
    return <BrowserRouter>{loggedIn ? renderProtectedRoutes() : renderPublicRoutes()}</BrowserRouter>;
}

export default App;
